// Module-level pub/sub bus for `counts:invalidate` events delivered over
// Socket.io. Decouples CountContext from SocketIOContext so the two
// providers don't have to live in a specific React tree order.
//
// The SocketIOProvider publishes an event here whenever it receives a
// `counts:invalidate` from the backend; CountContext subscribes here to
// trigger debounced refetches for the affected keys.

const listeners = new Set();

export const publishCountsInvalidate = payload => {
  for (const cb of listeners) {
    try {
      cb(payload);
    } catch (err) {
      console.error('countInvalidationBus listener failed:', err);
    }
  }
};

export const subscribeCountsInvalidate = cb => {
  if (typeof cb !== 'function') return () => {};
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};
